"use strict";
// models/calculs.js
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculTotalDocument = exports.calculLigne = exports.copierFacture = void 0;
const globals_1 = require("models/globals");
const lists_1 = require("./lists");
function copierFacture(facture, form, idTypeDocument) {
    let multiplicateur = 1;
    if (idTypeDocument == 14) {
        // inversion du signe des quantités
        multiplicateur = -1;
    }
    facture.idTypeDocument = idTypeDocument;
    facture.typeDocument = (lists_1.typeDocumentList.find(o => o.id == facture.idTypeDocument)).value;
    facture.unid = "";
    let numDoc = facture.numeroDocument;
    facture.numeroDocument = "";
    facture.dateDocument = new Date();
    form.setValues(facture);
    let lignes = $$("factureLignesGridId");
    let gridId = lignes.getFirstId();
    let item = lignes.getItem(gridId);
    while (item) {
        item["idDocument"] = "";
        item.idTypeDocument = idTypeDocument;
        item["unid"] = "";
        item["quantite"] = multiplicateur * item["quantite"];
        calculLigne(item);
        gridId = lignes.getNextId(gridId, 1);
        item = lignes.getItem(gridId);
    }
    // ajout de la référence Avoir sur Facture N°
    if (idTypeDocument == 14 && numDoc.length > 0) {
        let data = { unid: "", designation: (0, globals_1._)("Avoir sur Facture N° ") + numDoc };
        lignes.add(data, 0);
    }
    lignes.refreshColumns();
    calculTotalDocument(lignes);
}
exports.copierFacture = copierFacture;
function calculLigne(item) {
    // Pour un commentaire, pas de prix de vente, de code TVA, de prix d'achat
    if (item["idNature"] == 3) {
        item["prixVente"] = null;
        item["remiseLigne"] = null;
        item["prixNet"] = null;
        item["quantite"] = null;
        item["codeTVA"] = null;
        item["totalLigne"] = null;
        return;
    }
    // La norme dit : il faut appliquer l'arrondi aux résultats de calcul finaux, et non aux résultats intermédiaires
    // Il ne faut donc pas arrondir le prix net.
    if (item["prixVente"]) {
        if (item["remiseLigne"]) {
            item["prixNet"] = ((item["prixVente"] * (100 - item["remiseLigne"])) / 100);
        }
        else {
            item["prixNet"] = item["prixVente"];
        }
        if (item["quantite"]) {
            item["totalLigne"] = (item["prixNet"] * item["quantite"]).toFixed(2);
        }
        else {
            item["totalLigne"] = null;
        }
    }
    else {
        item["remiseLigne"] = null;
        item["prixNet"] = null;
        item["quantite"] = null;
        item["codeTVA"] = null;
        item["totalLigne"] = null;
    }
}
exports.calculLigne = calculLigne;
function calculTotalDocument(me) {
    globals_1.lv2.trace("Calcul total document");
    let calcStartTime = Date.now();
    let grid = me.$scope.$$("factureLignesGridId");
    let idLigne = grid.getFirstId();
    let ligne = grid.getItem(idLigne);
    let idTVA;
    let tva;
    // Jusqu'à 3 taux de TVA, avec code taux et montant
    let cc = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
    // Total pour chaque code TVA
    let tt = [0, 0, 0];
    // Nombre illimité de codes natures différents, avec code, montant HT
    let listeCodeNature = [];
    let listeMontantParNature = [];
    let idNature;
    let nature;
    me.$scope.$$("factureValide").setValue("Ok");
    // Totalisation des totaux des lignes par taux de tva
    while (ligne) {
        idTVA = ligne.idTVA;
        if (idTVA > 0) {
            tva = (0, lists_1.tvaList)().find(o => o.id == idTVA);
            let ok = false;
            for (let i = 0; i < 3; i++) {
                if (!cc[i][0]) {
                    cc[i][0] = idTVA;
                    cc[i][1] = Number(tva.taux);
                }
                if (cc[i][0] == idTVA) {
                    cc[i][2] = cc[i][2] + Number(ligne.totalLigne);
                    ok = true;
                    break;
                }
            }
            if (!ok) {
                webix.alert({
                    text: (0, globals_1._)("Trop de taux de TVA différents dans le même document"),
                    modal: true
                });
                me.$scope.$$("factureValide").setValue("Trop de taux de TVA");
                return;
            }
        }
        // calcul des totaux hors taxes par idNature, donc par compte de vente
        if (Number(ligne.totalLigne) > 0) {
            // si l'idNature n'est pas précisé, il prend la valeur par défaut "Prestation"
            if (ligne.idNature == undefined || Number(ligne.idNature) < 1) {
                ligne.idNature = globals_1.lv2.app.idNatureDefaut;
            }
            idNature = ligne.idNature;
            nature = lists_1.natureArticle.find(o => o.id == idNature);
            for (let i = 0; i <= listeCodeNature.length; i++) {
                if (!listeCodeNature[i]) {
                    // lv2.trace(i);
                    listeCodeNature[i] = idNature;
                    listeMontantParNature[i] = 0;
                }
                if (listeCodeNature[i] == idNature) {
                    listeMontantParNature[i] += Number(ligne.totalLigne);
                    break;
                }
            }
        }
        // ligne suivante
        idLigne = grid.getNextId(idLigne);
        ligne = grid.getItem(idLigne);
    }
    if (cc[0][0]) {
        tva = (0, lists_1.tvaList)().find(o => o.id == cc[0][0]);
        me.$scope.$$("codeTVA1").setValue(cc[0][0]);
        me.$scope.$$("libTVA1").setValue(tva.value);
        me.$scope.$$("tauxTVA1").setValue(cc[0][1]);
        me.$scope.$$("totalHT1").setValue(cc[0][2]);
        tt[0] = cc[0][2];
        let mtva = Math.round(cc[0][1] * cc[0][2]) / 100;
        me.$scope.$$("montantTVA1").setValue(mtva);
        tt[1] = mtva;
    }
    else {
        me.$scope.$$("codeTVA1").setValue("");
        me.$scope.$$("libTVA1").setValue("");
        me.$scope.$$("tauxTVA1").setValue("");
        me.$scope.$$("totalHT1").setValue("");
        me.$scope.$$("montantTVA1").setValue("");
    }
    if (cc[1][0]) {
        tva = (0, lists_1.tvaList)().find(o => o.id == cc[1][0]);
        me.$scope.$$("codeTVA2").setValue(cc[1][0]);
        me.$scope.$$("libTVA2").setValue(tva.value);
        me.$scope.$$("tauxTVA2").setValue(cc[1][1]);
        me.$scope.$$("totalHT2").setValue(cc[1][2]);
        tt[0] = tt[0] + cc[1][2];
        let mtva = Math.round(cc[1][1] * cc[1][2]) / 100;
        me.$scope.$$("montantTVA2").setValue(mtva);
        tt[1] = tt[1] + mtva;
    }
    else {
        me.$scope.$$("codeTVA2").setValue("");
        me.$scope.$$("libTVA2").setValue("");
        me.$scope.$$("tauxTVA2").setValue("");
        me.$scope.$$("totalHT2").setValue("");
        me.$scope.$$("montantTVA2").setValue("");
    }
    if (cc[2][0]) {
        tva = (0, lists_1.tvaList)().find(o => o.id == cc[2][0]);
        me.$scope.$$("codeTVA3").setValue(cc[2][0]);
        me.$scope.$$("libTVA3").setValue(tva.value);
        me.$scope.$$("tauxTVA3").setValue(cc[2][1]);
        me.$scope.$$("totalHT3").setValue(cc[2][2]);
        tt[0] = tt[0] + cc[2][2];
        let mtva = Math.round(cc[2][1] * cc[2][2]) / 100;
        me.$scope.$$("montantTVA3").setValue(mtva);
        tt[1] = tt[1] + mtva;
    }
    else {
        me.$scope.$$("codeTVA3").setValue("");
        me.$scope.$$("libTVA3").setValue("");
        me.$scope.$$("tauxTVA3").setValue("");
        me.$scope.$$("totalHT3").setValue("");
        me.$scope.$$("montantTVA3").setValue("");
    }
    tt[2] = (tt[0] + tt[1]);
    me.$scope.$$("totalHT").setValue(fin(tt[0]));
    me.$scope.$$("totalTVA").setValue(fin(tt[1]));
    me.$scope.$$("totalTTC").setValue(fin(tt[2]));
    // introduit pour la facturation TTC
    me.$scope.$$("totalTTC2").setValue(fin(tt[2]));
    // if (me.$scope.$$("idTypeDocument").getValue() == 1 && tt[0] < 0) {
    // 	webix.alert(_("Le montant HT de la facture est négatif. ") + _("Il est obligatoire de faire un avoir séparé."));
    // 	me.$scope.$$("factureValide").setValue("Facture négative");
    // }
    // if (me.$scope.$$("idTypeDocument").getValue() == 14 && tt[0] > 0) {
    // 	webix.alert(_("Le montant HT de l'avoir est positif'. ") + _("Il est obligatoire de faire une facture."));
    // 	me.$scope.$$("factureValide").setValue("Avoir positif");
    // }
    if (tt[2] > 100000000 || tt[2] < -100000000) {
        webix.alert((0, globals_1._)("Le total TTC d'un document ne peut pas dépasser 100 millions d'Euros."));
        me.$scope.$$("factureValide").setValue("Dépassement de 100 millions d'Euros.");
    }
    // facturation TTC, affichage des montants de prestations et de fournitures
    let montantPrestations = 0;
    let montantFournitures = 0;
    for (let i = 0; i < listeCodeNature.length; i++) {
        if (listeCodeNature[i] == 2) {
            montantPrestations = listeMontantParNature[i];
        }
        ;
        if (listeCodeNature[i] == 1) {
            montantFournitures = listeMontantParNature[i];
        }
        ;
    }
    me.$scope.$$("totalPrestations").setValue(fin(montantPrestations));
    me.$scope.$$("totalFournitures").setValue(fin(montantFournitures));
    // Pour la facturation TTC, vérifier que la somme des prestations et des fournitures est bien égale au
    // pseudo-total TTC
    if (globals_1.lv2.ihm.comptabiliteTenueHorsTaxes == "Non") {
        let sommePS = montantPrestations + montantFournitures;
        if (me.$scope.$$("totalTTC2").getValue() != sommePS) {
            webix.alert((0, globals_1._)("Certaines lignes ne sont ni Prestation, ni Fourniture.") + (0, globals_1._)(" Veuillez corriger pour valider votre facture."));
            me.$scope.$$("factureValide").setValue("Ligne non prestation ou fourniture");
        }
    }
    // let calcTime = Date.now() - calcStartTime;
    // lv2.trace("Durée de calcul : " + calcTime);
    // for (let i = 0; i < listeCodeNature.length; i++) {
    // 	lv2.trace("Total : " + listeCodeNature[i] + " = " + listeMontantParNature[i]);
    // }
}
exports.calculTotalDocument = calculTotalDocument;
function fin(x) {
    // lv2.trace(x + "---" + Number.parseFloat(x).toFixed(2))
    return Number.parseFloat(x).toFixed(2);
}
